<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="@/common/imgs/news.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-newslist">
      <div class="newslist-title">
        <span>
          <h2>华剑新闻</h2>/<i>HuaJian News</i>
          <p>文章篇数：{{total}}篇</p>
        </span>
      </div>
      <div class="list-content">
        <ul>
          <li v-for="item in newslist" :key="item.id">
            <router-link :to="{path: '/Detail',query:{id: item.id}}">
              <i class="el-icon-s-flag"></i>
              <span>{{item.createTime | subTime}}</span>丨
              <p>{{item.title}}</p>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="list-page">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pagesize" :hide-on-single-page="true"
          :current-page="currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'

  export default {
    name: 'Articles',
    data() {
      return {
        currentPage: 1, //当前页数
        pagesize: 10 //每页条数
      }
    },
    created() {
      this.$store.dispatch('getData', this.currentPage);
    },
    computed: {
      ...mapState(['newslist', 'total'])
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    methods: {
      handleCurrentChange: function(currentPage) {
        console.log(currentPage);
        this.$store.dispatch('getData', currentPage); //点击第几页
      },
    },
    filters: {
      subTime: function(str) {
        return str.substr(0, 10)
      }
    }
  }
</script>
<style>
  .news-newslist {
    width: 1200px;
    margin: 0 auto;
  }

  .newslist-title {
    width: 100%;
    height: 100px;
  }

  .newslist-title span {
    display: block;
    width: 320px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    text-align: center;
    margin: 20px auto 0;
  }

  .newslist-title h2 {
    display: block;
    float: left;
    color: #033993;
    font-size: 26px;
  }

  .newslist-title i {
    font-size: 20px;
    color: #666666;
    font-style: normal;
    margin-left: 20px;
  }

  .list-content {
    width: 100%;
    margin: 0 auto 40px;
    border-top: 1px dashed #999;
    border-bottom: 1px dashed #999;
  }

  .list-content ul {
    padding: 10px 0;
    min-height: 500px;
  }

  .list-content a {
    position: relative;
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
    color: #606266;
  }

  .list-content a:hover {
    color: #409eff;
  }

  .list-content p {
    display: inline;
  }

  .list-page {
    width: 100%;
    height: 40px;
    margin: 0 auto 40px;
    text-align: center;
  }

  @media screen and (max-width: 1120px) {
    #footer {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Articles.vue